const search = {
  search: {
    // نص زر البحث في شريط البحث الرئيسي.
    search: 'بحث',
    // شارة المدينة في /search (?cityId=…)، بصيغة شارة الحي أدناه. كانت تظهر بالإنجليزية.
    city: {
      chip: 'المدينة: {{name}}',
      clear: 'إزالة المدينة',
    },
    // البحث عن حي
    district: {
      placeholder: 'ابحث عن حي…',
      label: 'البحث عن حي',
      noResults: 'لا توجد أحياء مطابقة',
      listings_one: 'إعلان {{count}}',
      listings_other: '{{count}} إعلان',
      // صيغ الجمع العربية الناقصة (zero/two/few/many)، كما في location أدناه:
      // بدونها يظهر النص الاحتياطي الإنجليزي للأعداد مثل 3-10 و11-99.
      listings_zero: 'لا إعلانات',
      listings_two: 'إعلانان',
      listings_few: '{{count}} إعلانات',
      listings_many: '{{count}} إعلانًا',
      chip: 'الحي: {{name}}',
      clear: 'إزالة الحي',
    },
    // البحث الموحّد عن مدينة أو حي
    location: {
      placeholder: 'مدينة أو حي…',
      label: 'ابحث عن مدينة أو حي',
      noResults: 'لا توجد مواقع مطابقة',
      cityLabel: 'مدينة',
      districtLabel: 'حي',
      listings_one: 'إعلان {{count}}',
      listings_other: '{{count}} إعلان',
      // صيغ الجمع العربية الناقصة (zero/two/few/many) — بدونها يظهر النص
      // الاحتياطي الإنجليزي للأعداد مثل 3-10 (few) و11-99 (many).
      listings_zero: 'لا إعلانات',
      listings_two: 'إعلانان',
      listings_few: '{{count}} إعلانات',
      listings_many: '{{count}} إعلانًا',
      // شارة درجة الحي في اقتراحات البحث (محسوبة من بيانات إعلانات فعلية)
      districtScore: 'درجة الحي',
      // مفردات درجة الحي المشتركة (خريطة، لوحة معلومات الحي، صفحة العقار)
      // ملاحظة: العربية لها ست صيغ جمع (zero/one/two/few/many/other) — يجب
      // تعريفها كلها وإلا عرض i18next اسم المفتاح للأعداد مثل 86 (many).
      districtScoreNone: 'بدون درجة',
      districtScoreTooltip: 'محسوبة من بيانات إعلانات فعلية في الحي',
      districtScoreComputedFrom_zero: 'لا توجد إعلانات كافية في الحي',
      districtScoreComputedFrom_one: 'محسوبة من بيانات إعلان فعلي واحد في الحي',
      districtScoreComputedFrom_two: 'محسوبة من بيانات إعلانين فعليين في الحي',
      districtScoreComputedFrom_few: 'محسوبة من بيانات {{count}} إعلانات فعلية في الحي',
      districtScoreComputedFrom_many: 'محسوبة من بيانات {{count}} إعلانًا فعليًا في الحي',
      districtScoreComputedFrom_other: 'محسوبة من بيانات {{count}} إعلان فعلي في الحي',
      scoreFactors: {
        livability: 'جودة المعيشة',
        investment: 'جاذبية الاستثمار',
        family: 'ملاءمة العائلات',
        safety: 'الأمان',
      },
    },
    // نطاق البحث «ضمن N كم» حول الحي المختار
    radius: {
      label: 'نطاق البحث',
      exact: 'هذا الحي فقط',
      within: '+ {{km}} كم',
    },
    // ميزات البحث بالذكاء الاصطناعي
    smartSuggestions: 'اقتراحات ذكية',
    searching: 'جارٍ البحث...',
    noResults: 'لم يتم العثور على نتائج',
    tryDifferent: 'جرّب كلمة بحث مختلفة',
    recent: 'عمليات البحث الأخيرة',
    clearRecent: 'مسح',
    popular: 'الأكثر بحثاً',
    properties: 'عقار',
    tipTitle: 'نصيحة للبحث الذكي',
    tip: 'جرب البحث بلغة طبيعية مثل "شقة 3 غرف في الرياض أقل من 10000" للحصول على نتائج ذكية',
    voiceSearch: 'البحث الصوتي',
    voiceNotSupported: 'البحث الصوتي غير مدعوم في متصفحك',
    listening: 'جارٍ الاستماع...',
    inputLabel: 'ابحث عن عقارات',
    suggestionTypes: {
      property: 'عقار',
      city: 'مدينة',
      neighborhood: 'حي',
      propertyType: 'نوع العقار',
      amenity: 'ميزة',
      ai: 'اقتراح ذكي',
    },
    ai: {
      badgeVector: 'بحث ذكي',
      badgeHybrid: 'بحث ذكي',
      badgeReranked: 'ترتيب ذكي',
      whyMatches: 'لماذا يتطابق هذا',
      understood: 'فهمنا طلبك:',
      showingResultsFor: 'نعرض نتائج لـ',
      searchInstead: 'ابحث عن النص الأصلي بدلاً من ذلك',
      upgradeTitle: 'ترتيب أذكى بالذكاء الاصطناعي',
      upgradeDescription: 'يحصل المشتركون على نتائج مُرتّبة بالذكاء الاصطناعي وفهم للغة الطبيعية، إضافةً إلى البحث الذكي المجاني للجميع.',
      upgradeCta: 'عرض الباقات',
      comingSoon: 'بحث ذكي - قريباً',
    },
    header: {
      title: 'اعثر على منزلك التالي',
      subtitle:
        'استخدم فلاتر مصممة خصيصًا لتظهر لك القوائم التي تتماشى مع أسلوب حياتك وأهدافك الاستثمارية والأحياء المفضلة لديك.',
    },
      results: {
        count: '{{count}} قائمة مطابقة',
        // Page header (owner, 2026-10-07: one title, the count once). {{n}} is the
        // formatted number; the noun agrees with it through the plural forms
        // (one 1 · two 2 · few 3-10 · many 11-99 · other 100+).
        titleRent: 'عقارات للإيجار',
        titleBuy: 'عقارات للبيع',
        titleAll: 'عقارات',
        titleIn: '{{title}} في {{place}}',
        placeDefault: 'السعودية',
        total: '{{n}} عقار',
        total_zero: '{{n}} عقار',
        total_one: 'عقار واحد',
        total_two: 'عقاران',
        total_few: '{{n}} عقارات',
        total_many: '{{n}} عقاراً',
        total_other: '{{n}} عقار',
        // The filter bar's pills.
        allFilters: 'كل الفلاتر',
        pricePill: 'السعر',
        done: 'تم',
        // زر الدرج «عرض 2,510 عقار»؛ {{what}} هو نص العدد أعلاه (total).
        show: 'عرض {{what}}',
        // شريط الخريطة المصغّرة فوق النتائج.
        inDrawnArea: '{{what}} ضمن المنطقة المرسومة',
        inPlace: '{{what}} في {{place}}',
        viewOnMap: 'عرض على الخريطة',
        clearArea: 'مسح المنطقة',
        countWithQuery: '{{count}} قائمة لـ "{{query}}"',
        sortLabel: 'ترتيب حسب',
        sortOptions: {
          newest: 'الأحدث أولًا',
          oldest: 'الأقدم أولًا',
          priceLow: 'السعر: من الأقل إلى الأعلى',
          priceHigh: 'السعر: من الأعلى إلى الأقل',
        },
        // طرق عرض النتائج: «عرض شامل» شبكة مختصرة بأكبر عدد من العقارات، و«عرض
        // البطاقات» بطاقة كاملة لكل عقار. السطر الشارح يظهر تحت المفتاح.
        viewModes: {
          label: 'طريقة العرض',
          grid: 'عرض شامل',
          cards: 'عرض البطاقات',
          map: 'الخريطة',
          list: 'القائمة',
          gridShort: 'شامل',
          cardsShort: 'بطاقات',
        },
        loading: 'جارٍ جمع أفضل الفرص...',
        loadingMore: 'جارٍ تحميل المزيد من العقارات...',
        allLoaded: 'تم تحميل جميع العقارات',
        emptyTitle: 'لم تطابق أي عقارات معاييرك',
        emptyDescription:
          'حاول توسيع نطاق السعر أو تعديل الموقع أو إعادة تعيين الفلاتر لاستكشاف المزيد من السوق.',
        emptyReset: 'إعادة تعيين الفلاتر',
        summary: 'تم العثور على {{count}} عقار',
        toggleFilters: {
          open: 'فتح الفلاتر',
          close: 'إغلاق الفلاتر',
          hint: 'استخدم الفلاتر لتضييق نطاق البحث وإيجاد العقارات المثالية بسرعة.',
        },
      },
      filters: {
        title: 'الفلاتر',
        subtitle: 'صقل النتائج لتلائم متطلباتك',
        clear: 'مسح الكل',
        quickTitle: 'فلاتر سريعة',
        quick: {
          under400: 'أقل من 400 ألف {{currency}}',
          between400And700: '400 ألف - 700 ألف {{currency}}',
          above700: 'أكثر من 700 ألف {{currency}}',
          petFriendly: 'مسموح بالحيوانات فقط',
        },
        searchLabel: 'بحث بالكلمات المفتاحية',
        searchPlaceholder: 'جرّب: «فيلا عائلية فيها حديقة قريبة من المدارس»…',
        resetSearch: 'مسح الكلمة المفتاحية',
        priceLabel: 'نطاق الميزانية',
        minPlaceholder: 'أدنى سعر',
        maxPlaceholder: 'أعلى سعر',
        bedroomsLabel: 'غرف النوم',
        bathroomsLabel: 'دورات المياه',
        anyOption: 'أي',
        propertyTypeLabel: 'نوع العقار',
        propertyTypeOptions: {
          // سكني
          APARTMENT: 'شقة',
          VILLA: 'فيلا',
          DUPLEX: 'دوبلكس',
          STUDIO: 'استوديو',
          PENTHOUSE: 'بنتهاوس',
          FLOOR: 'دور',
          ROOM: 'غرفة',
          TOWNHOUSE: 'تاون هاوس',
          RESIDENTIAL_BUILDING: 'عمارة سكنية',
          REST_HOUSE: 'استراحة',
          CHALET: 'شاليه',
          CONDO: 'كوندومينيوم',
          // أراضي
          LAND: 'أرض',
          RESIDENTIAL_LAND: 'أرض سكنية',
          COMMERCIAL_LAND: 'أرض تجارية',
          AGRICULTURAL_LAND: 'أرض زراعية',
          INDUSTRIAL_LAND: 'أرض صناعية',
          FARM: 'مزرعة',
          // تجاري
          OFFICE: 'مكتب',
          SHOP: 'محل',
          WAREHOUSE: 'مستودع',
          SHOWROOM: 'معرض',
          WORKSHOP: 'ورشة',
          FACTORY: 'مصنع',
          COMMERCIAL_BUILDING: 'عمارة تجارية',
          COMMERCIAL: 'تجاري',
          BUILDING: 'عمارة',
          // ضيافة ومؤسسي
          HOTEL: 'فندق',
          MALL: 'مول',
          SCHOOL: 'مدرسة',
          HEALTH_CENTER: 'مركز صحي',
          STATION: 'محطة',
          // أسماء بديلة (لعرض بطاقات العقارات - لا تظهر كأزرار فلترة)
          House: 'منزل',
          Apartment: 'شقة',
          Condo: 'كوندومينيوم',
          Townhouse: 'تاون هاوس',
          Studio: 'استوديو',
          Penthouse: 'بنتهاوس',
        },
        showMore: 'خيارات إضافية',
        showLess: 'خيارات أقل',
        amenities: {
          parking: 'موقف سيارات خاص',
          petFriendly: 'مسموح بالحيوانات الأليفة',
          furnished: 'مفروشة',
          swimmingPool: 'مسبح',
          gym: 'صالة رياضية',
          garden: 'حديقة',
          elevator: 'مصعد',
          security: 'حراسة أمنية',
        },
        activeTitle: 'فلاتر مفعّلة:',
        priceChip: 'نطاق الميزانية',
        // لوحة الفلاتر في صفحة البحث (PropertyFilters): مفتاحا «نوع العرض» و«الفئة».
        listingTypeLabel: 'نوع العرض',
        listingTypeRent: 'للإيجار',
        listingTypeBuy: 'للبيع',
        listingTypeAll: 'الكل',
        categoryLabel: 'الفئة',
        categoryAll: 'الكل',
        categoryResidential: 'سكني',
        categoryCommercial: 'تجاري',
        // اسم زر الإزالة في شارة «فلاتر مفعّلة» لقارئ الشاشة.
        removeFilter: 'إزالة الفلتر: {{label}}',
      },
      card: {
        bedrooms: '{{count}} غرف نوم',
        bedrooms_one: '{{count}} غرفة نوم',
        bedrooms_other: '{{count}} غرف نوم',
        bathrooms: '{{count}} دورات مياه',
        bathrooms_one: '{{count}} دورة مياه',
        bathrooms_other: '{{count}} دورات مياه',
        area: '{{value}} {{unit}}',
        parking: 'موقف سيارات خاص',
        petFriendly: 'مسموح بالحيوانات الأليفة',
        furnished: 'مفروشة',
        listedOn: 'مدرَج بتاريخ {{date}}',
        pricePerSqm: '{{value}} {{currency}} لكل {{unit}}',
        viewDetails: 'عرض التفاصيل',
        addToFavorites: 'إضافة إلى المفضلة',
        removeFromFavorites: 'إزالة من المفضلة',
        // صاحب الإعلان (فرد أو وسيط أو شركة): تبويب البطاقة والاسم البديل.
        advertiser: 'المعلن',
        // اسم السعر لقارئ الشاشة على البطاقة والخريطة (كان ناقصاً بالعربية فيُقرأ اسم المفتاح).
        priceAccessible: '{{price}} {{currency}}',
        // أسهم صور البطاقة.
        prevImage: 'الصورة السابقة',
        nextImage: 'الصورة التالية',
        photoOf: 'الصورة {{n}} من {{total}}',
        // زر الاتصال في بطاقة النتيجة، والمسافة من المعلم المختار في «قريب من».
        call: 'اتصال',
        distanceFrom: '{{km}} كم من {{place}}',
        actionDisabled: {
          pending: 'تحت التفاوض',
          sold: 'مباع',
          rented: 'مؤجر',
        },
      },
      statuses: {
        available: 'متاح',
        pending: 'تحت التفاوض',
        sold: 'مباع',
        rented: 'مؤجر',
      },
      map: {
        loading: 'جارٍ تحميل القوائم على الخريطة...',
        zoomIn: 'تكبير',
        zoomOut: 'تصغير',
        reset: 'إعادة تعيين العرض لإظهار كل القوائم',
        empty: 'لا توجد عقارات معروضة على الخريطة',
        attribution: 'بيانات الخريطة (c) مساهمو OpenStreetMap',
        bedrooms: '{{count}} غ.ن',
        bathrooms: '{{count}} دورات مياه',
        area: '{{value}} {{unit}}',
        viewProperty: 'عرض العقار',
        call: 'اتصل بالمعلن',
        countLabel: '{{count}} عقارات',
        countLabel_zero: 'لا توجد عقارات على الخريطة',
        countLabel_one: 'عقار واحد',
        countLabel_two: 'عقاران',
        countLabel_few: '{{count}} عقارات',
        countLabel_many: '{{count}} عقارات',
        countLabel_other: '{{count}} عقارات',
        // رسم للبحث
        drawToSearch: 'ارسم للبحث',
        drawInstructions: 'ارسم شكلًا على الخريطة لتصفية العقارات داخل تلك المنطقة',
        clearDrawing: 'مسح الرسم',
        propertiesInArea: '{{count}} عقارات في المنطقة المحددة',
        // الشريط الجانبي
        sidebar: {
          title: 'العقارات',
          sortByDistance: 'مرتبة حسب المسافة',
          sortByPrice: 'ترتيب حسب السعر',
          noProperties: 'لا توجد عقارات في هذه المنطقة',
          viewAll: 'عرض الكل',
        },
        // التجميع
        cluster: {
          properties: '{{count}} عقارات',
        },
      },
      // بالقرب منك / البحث عن معالم
      nearYou: {
        title: 'بالقرب من معلم',
        description: 'اعثر على عقارات بالقرب من المدارس والمولات والمستشفيات والمزيد',
        searchPlaceholder: 'ابحث عن مدرسة، مول، مستشفى...',
        radiusLabel: 'نطاق البحث',
        radius: {
          '1km': '1 كم',
          '3km': '3 كم',
          '5km': '5 كم',
          '10km': '10 كم',
        },
        recentLandmarks: 'عمليات البحث الأخيرة',
        noResults: 'لم يتم العثور على معالم',
        near: 'بالقرب من',
        fromLandmark: 'من {{landmark}}',
        landmarkTypes: {
          school: 'مدرسة',
          university: 'جامعة',
          hospital: 'مستشفى',
          shopping_mall: 'مول',
          transit_station: 'مترو',
          park: 'حديقة',
          mosque: 'مسجد',
          restaurant: 'مطعم',
          gym: 'نادي رياضي',
        },
      },
      // الجولة الافتراضية
      virtualTour: {
        badge: '360°',
        title: 'جولة افتراضية',
        enter: 'ابدأ الجولة 360°',
        exit: 'إنهاء الجولة',
        fullscreen: 'ملء الشاشة',
        exitFullscreen: 'الخروج من ملء الشاشة',
        controls: {
          zoomIn: 'تكبير',
          zoomOut: 'تصغير',
          reset: 'إعادة تعيين العرض',
          autoRotate: 'دوران تلقائي',
        },
        loading: 'جارٍ تحميل الجولة الافتراضية...',
        error: 'فشل تحميل الجولة الافتراضية',
        notAvailable: 'الجولة الافتراضية غير متوفرة',
      },
  },
};

export default search;
